module.exports = __webpack_public_path__ + "assets/img/storage.71e27b61.png";